module.exports = __webpack_public_path__ + "img/wasd.efcb68c2.png";